// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_rba_main_div {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.user_rba_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.user_rba_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_rba_summary {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
}

.user_rba_score {
    font-size: 14px;
    color: var(--text-primary);
}

.user_rba_risk_badge {
    padding: 4px 12px;
    border-radius: var(--radius-sm);
    font-size: 13px;
    font-weight: 700;
}

.user_rba_risk_low {
    background-color: #dcfce7;
    color: #16a34a;
}

.user_rba_risk_medium {
    background-color: #fef9c3;
    color: #ca8a04;
}

.user_rba_risk_high {
    background-color: #fee2e2;
    color: #dc2626;
}

.user_rba_chevron {
    font-size: 12px;
    color: var(--text-muted);
}

.user_rba_answers {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border);
}

.user_rba_answer_row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 10px 0;
    border-bottom: 1px solid var(--border);
}

.user_rba_answer_row:last-child {
    border-bottom: none;
}

.user_rba_question {
    margin: 0;
    font-size: 13px;
    color: var(--text-muted);
    flex: 1 1;
}

.user_rba_answer {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    text-align: right;
    flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserRbaMatrix/userRbaMatrix.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,wBAAwB;IACxB,SAAO;AACX;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".user_rba_main_div {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.user_rba_header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    user-select: none;\n}\n\n.user_rba_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_rba_summary {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n}\n\n.user_rba_score {\n    font-size: 14px;\n    color: var(--text-primary);\n}\n\n.user_rba_risk_badge {\n    padding: 4px 12px;\n    border-radius: var(--radius-sm);\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.user_rba_risk_low {\n    background-color: #dcfce7;\n    color: #16a34a;\n}\n\n.user_rba_risk_medium {\n    background-color: #fef9c3;\n    color: #ca8a04;\n}\n\n.user_rba_risk_high {\n    background-color: #fee2e2;\n    color: #dc2626;\n}\n\n.user_rba_chevron {\n    font-size: 12px;\n    color: var(--text-muted);\n}\n\n.user_rba_answers {\n    display: flex;\n    flex-direction: column;\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border);\n}\n\n.user_rba_answer_row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 10px 0;\n    border-bottom: 1px solid var(--border);\n}\n\n.user_rba_answer_row:last-child {\n    border-bottom: none;\n}\n\n.user_rba_question {\n    margin: 0;\n    font-size: 13px;\n    color: var(--text-muted);\n    flex: 1;\n}\n\n.user_rba_answer {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    text-align: right;\n    flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
